import { product_promo_api_methods } from "./product_promo_code_api";
import { product_promo_api_helper_methods } from "./product_promo_code_api_helper";
import { product_promo_sale_methods } from "./product_promo_code_sale_helper";
import { product_promo_utility_methods } from "./product_promo_code_helper";

export default {
  data() {
    return ({
      discount_types: [],
      selected_product: null,
      selected_product_id: "",
      selected_base_profile_id: null,
      selected_products: [],
      catalogue_base_profile_id: null,
      is_catalogue_promo: false,
      product_promo_codes: [],
      is_loading: false,
      isLoading: false,
      promo_code_name: "",
      discount_type: "",
      discount_value: 0,
      start_date: null,
      end_date: null,
      usage_limit: 0,
      minimum_order_amount: 0,
      is_active: true,
      promo_errors: {},
      is_editing_product_promo: false,
      editing_product_promo_code_id: null,
      return_to_promo_manager: false,
      return_to_catalogue_promo_manager: false,
      share_menu_open: {},
      share_menu_position: {},
      catalogue_promo_codes: [],
      selected_sale_products: [],
      sale_base_profile_id: null,
      sale_applies_all: false,
      sale_discount_type: "",
      sale_discount_value: 0,
      sale_is_active: true,
      sale_start_date: "",
      sale_end_date: "",
    });
  },
  mounted() {
    this.fetch_discount_types();
  },
  computed: {
    min_start_date() {
      return this.get_date_time_local_string(new Date());
    },
    min_end_date() {
      return this.start_date || this.min_start_date;
    },
    min_datetime() {
      return this.get_date_time_local_string(new Date());
    },
    selected_sale_discount_type() {
      return (this.discount_types || []).find((option) => (
        String(option.value) === String(this.sale_discount_type)
      )) || null;
    },
    is_sale_percentage_discount() {
      const discount_type = this.selected_sale_discount_type;
      const type_name = String(discount_type?.name || "").toLowerCase();
      return type_name.includes("percentage");
    },
    sale_preview_products() {
      const discount_value = Number(this.sale_discount_value) || 0;
      return (this.selected_sale_products || []).map((product) => {
        const original_price = Number(
          product?.price ??
          0
        );
        const discounted_price = this.is_sale_percentage_discount
          ? Math.max(0, original_price - ((original_price * discount_value) / 100))
          : Math.max(0, original_price - discount_value);

        return {
          id: product?.id,
          name: product?.name,
          original_price,
          discounted_price,
          discount_label: this.is_sale_percentage_discount
            ? `-${discount_value}%`
            : `-R${this.format_amount(discount_value)}`,
        };
      });
    },
    is_valid_event() {
      return Boolean(
        this.sale_discount_type &&
        String(this.sale_discount_value).trim() &&
        this.sale_start_date &&
        this.sale_end_date
      );
    },
    is_event_dates_locked() {
      return false;
    },
  },
  watch: {
    start_date(new_value) {
      if (!new_value || !this.end_date) return;
      if (new Date(this.end_date).getTime() < new Date(new_value).getTime()) {
        this.end_date = null;
      }
    },
  },
  methods: {
    ...product_promo_utility_methods,
    ...product_promo_sale_methods,
    ...product_promo_api_methods,
    ...product_promo_api_helper_methods,
  },
};
